<router-outlet></router-outlet>
<ahp-toast></ahp-toast>
<div *ngIf="displaySpinner$ | async" @fadeInAndOut class="spinner--container">
	<ahp-spinner></ahp-spinner>
</div>
